"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PosTerminalScreen = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const KioskIdleTimer_1 = require("./KioskIdleTimer");
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10vh;

  h2 {
    text-align: center;
    font-size: 2.64vmin;
    font-weight: 400;
  }

  .svg-container {
    text-align: center;
    img {
      height: 273px;
    }
  }
`;
const PosTerminalScreen = ({ currentLocale, userData, stayId, openErrorDialog, onPaymentStatusSuccess, onPaymentStatusError, baseUrl, }) => {
    const [screenData, setScreenData] = (0, react_1.useState)(null);
    const [intervalData, setIntervalData] = (0, react_1.useState)(null);
    const interval = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (screenData)
            return;
        apiService_1.default
            .getAdyenConfigs(currentLocale, userData.token, stayId, true, 'pos_terminal', localStorage.getItem('stationToken'))
            .then((data) => {
            if (data.status === 'error') {
                onPaymentStatusError(data);
                return;
            }
            setScreenData(data);
            localStorage.setItem('paymentReference', data.paymentReference);
        })
            .catch(() => {
            openErrorDialog();
        });
    }, [setScreenData]);
    (0, react_1.useEffect)(() => {
        if (!screenData)
            return;
        const userToken = localStorage.getItem('kioskUserToken');
        apiService_1.default
            .checkPaymentProgress(currentLocale, userToken, screenData.paymentReference, true)
            .then((data) => {
            if (data.status === 'success') {
                onPaymentStatusSuccess(data);
            }
            else if (data.status === 'error') {
                onPaymentStatusError(data);
            }
            else if (data.status === 'retry') {
                if (data.interval) {
                    setIntervalData(data);
                }
            }
        })
            .catch(() => {
            openErrorDialog();
        });
    }, [screenData, setScreenData, setIntervalData]);
    (0, react_1.useEffect)(() => {
        if (!intervalData)
            return;
        const userToken = localStorage.getItem('kioskUserToken');
        interval.current = setInterval(() => {
            apiService_1.default
                .checkPaymentProgress(currentLocale, userToken, screenData.paymentReference, true)
                .then((data) => {
                if (data.status === 'success') {
                    clearInterval(interval.current);
                    onPaymentStatusSuccess(data);
                }
                else if (data.status === 'error') {
                    clearInterval(interval.current);
                    onPaymentStatusError(data.message);
                }
            })
                .catch(() => {
                clearInterval(interval.current);
                openErrorDialog();
            });
        }, intervalData.interval);
        setTimeout(() => {
            clearInterval(interval.current);
        }, KioskIdleTimer_1.TIME_UNTIL_IDLE);
    }, [intervalData, interval]);
    if (!screenData)
        return null;
    return (react_1.default.createElement(Wrapper, { "data-testid": "checkin-completed" },
        react_1.default.createElement("div", { className: "svg-container" },
            react_1.default.createElement("img", { src: screenData.image })),
        react_1.default.createElement("h2", null, screenData.texts.body)));
};
exports.PosTerminalScreen = PosTerminalScreen;
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue('currentLocale'),
    userData: store.getValue('userData'),
    kioskModeEnabled: store.getValue('kioskModeEnabled'),
    stayId: store.getValue('stayId'),
    posTerminalEnabled: store.getValue('posTerminalEnabled'),
    baseUrl: store.getValue('baseUrl'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.PosTerminalScreen));
